<template>
  <div class="calico-tooltip-page">
    <Tooltip
      header="Header"
      body="Body should appear here."
    />
  </div>
</template>

<script>
import Tooltip from '@/components/calico/tooltip/index.vue'

export default {
    name: 'TooltipPage',
    components: {
        Tooltip
    }
}
</script>

<style scoped lang="scss">
.calico-tooltip-page {
    @include inset-space($space-large);
    height: 100vh;
    background-color: #c5c5c5;
}
</style>